export default __webpack_public_path__ + "3f1e21dca6e31456c5c15909ad734ece.jpg";